module.exports = __webpack_public_path__ + "img/background1.ed50177e.jpg";